module.exports = __webpack_public_path__ + "img/vmc_aniv3_24Aug2021.2de18570.jpg";